export default __webpack_public_path__ + "static/media/SB-BIOLOGY-HIGH-SCHOOL-AP-U3.ad55b94b.jpg";